import { Button, Stack, Typography } from '@mui/material'
import { COLORS } from 'app-constants'
import JelledModal from 'components/JelledModal'
import useCheckMobileScreen from 'hooks/use-check-mobile-screen'

const FtuxModal = ({
  onClose,
  headerText,
  subtitleText,
  buttonText,
  onButtonClick,
  icon,
}: {
  onClose: () => void
  headerText: string
  subtitleText: string
  buttonText: string
  onButtonClick: () => void
  icon: React.ReactNode
}) => {
  const isMobile = useCheckMobileScreen()

  return (
    <JelledModal
      onClose={onClose}
      isOpen={true}
      width={isMobile ? 'calc(100% - 32px)' : '702px'}
      modalStyle={{
        backgroundColor: COLORS.PURE_WHITE,
        height: isMobile ? '100%' : '793px',
        marginLeft: isMobile ? '16px' : 0,
        marginRight: isMobile ? '16px' : 0,
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
      }}>
      <Stack
        height="50vh"
        justifyContent="center"
        alignItems="center"
        sx={{
          backgroundColor: COLORS.SPECIAL_FILL,
        }}>
        {icon}
      </Stack>

      <Stack p={6} textAlign="center" alignItems="center">
        <Typography variant="h3" color="secondary">
          {headerText}
        </Typography>

        <Typography
          variant="pS"
          my={3}
          sx={{
            color: COLORS.GRAY_2,
          }}>
          {subtitleText}
        </Typography>

        <Button
          variant="contained"
          color="primary"
          size="medium"
          onClick={() => {
            onButtonClick()
          }}
          sx={{
            width: 'fit-content',
          }}>
          {buttonText}
        </Button>
      </Stack>
    </JelledModal>
  )
}

export default FtuxModal
